import { render, staticRenderFns } from "./inviteArticles.vue?vue&type=template&id=a20f158a&scoped=true"
import script from "./inviteArticles.vue?vue&type=script&lang=js"
export * from "./inviteArticles.vue?vue&type=script&lang=js"
import style0 from "./inviteArticles.vue?vue&type=style&index=0&id=a20f158a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20f158a",
  null
  
)

export default component.exports